import { SubmissionError } from 'redux-form'
import { formatApiValidationErrors } from './Errors'
import { i18next } from 'app-support/contexts/I18nContext'

const getGlobalError = (error: any) => error?.response?.data?.Error
const getValidationError = (error: any) => error?.response?.data?.ValidationErrors

export const generateSubmissionError = (error: any) => {
  let formErrors: { [key: string]: string } = {}

  const validationErrors = getValidationError(error)

  if (validationErrors) {
    formErrors = formatApiValidationErrors(validationErrors)
  }

  const globalError = getGlobalError(error)

  return new SubmissionError({
    _error: globalError || i18next.t('global.form_errors_found'),
    ...formErrors
  })
}
